import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-4xl font-bold" }
const _hoisted_4 = { class: "text-medium" }
const _hoisted_5 = { class: "text-sm text-medium" }
const _hoisted_6 = { class: "text-md text-center font-medium" }
const _hoisted_7 = { class: "text-medium" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_9 = {
  key: 0,
  class: "text-xs font-semibold text-medium text-opacity-30"
}
const _hoisted_10 = { class: "text-xs text-primary" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Order", -1)

import { IonButtons, IonToolbar, IonIcon, useIonRouter } from '@ionic/vue';
import { chevronForwardSharp } from 'ionicons/icons';

import AppLayout from '@/layout/AppLayout.vue';
import FormInput from '@/views/form/FormInput.vue';
import FormTextarea from '@/views/form/FormTextarea.vue';
import FormVoiceSelector from '@/views/form/FormVoiceSelector.vue';
import { useCart } from '@/stores/cart';
import { onMounted, watch } from 'vue';
import { wordTruncate } from '@/utils/filters';
import CustomButton from '@/components/CustomButton.vue';
import { useRoute } from 'vue-router';
import { useNavigation } from '@/stores/navigation';
import { successToast, warningToast } from '@/utils/ionic-utils';
import FormPart from '@/components/FormPart.vue';
import { useSetup } from '@/stores/setup';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const cart = useCart();
const setup = useSetup();
const navigation = useNavigation();

const route = useRoute();
const router = useIonRouter();

const next = () => {
  router.push({ name: 'summary', query: cart.params });
};

watch(cart.form, async () => {
  if (cart.scriptWordCount > 80) {
    cart.form.Voicing_Script = wordTruncate(cart.form.Voicing_Script, 80);
  }
  await cart.commitForm();
});

onMounted(() => {
  navigation.refresh(route, router);
  if (cart.toPayment) {
    navigation.goTo('payment', true);
    warningToast('You have an unpaid order!');
  }
  if (cart.payment) {
    navigation.goTo('thank-you', true, { id: cart?.deal?.id });
    successToast('You have already paid for your order.');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "w-40",
          src: _unref(setup).logo,
          alt: "Logo"
        }, null, 8, _hoisted_2),
        _createElementVNode("h1", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(setup).titleGray), 1),
          _createTextVNode(" " + _toDisplayString(_unref(setup).titleDark), 1)
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(setup).subtitle), 1),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(setup).ctoText), 1),
          _createTextVNode(" - just " + _toDisplayString(_unref(cart).displayPrice()) + " ", 1),
          (_unref(cart).currency === 'nzd')
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "+15% GST"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(FormVoiceSelector),
        _createVNode(FormPart, { step: "2" }, {
          default: _withCtx(() => [
            _createVNode(FormInput, {
              placeholder: "First Name",
              type: "text",
              modelValue: _unref(cart).form.First_Name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(cart).form.First_Name) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormInput, {
              placeholder: "Last Name",
              type: "text",
              modelValue: _unref(cart).form.Last_Name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(cart).form.Last_Name) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormInput, {
              placeholder: "Email",
              type: "email",
              modelValue: _unref(cart).form.Email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(cart).form.Email) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormInput, {
              placeholder: "Company",
              type: "text",
              modelValue: _unref(cart).form.Company,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(cart).form.Company) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(FormInput, {
              placeholder: "Phone",
              type: "tel",
              modelValue: _unref(cart).form.Phone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(cart).form.Phone) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(FormPart, { step: "3" }, {
          default: _withCtx(() => [
            (_unref(setup).messageHelpText.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(setup).messageHelpText), 1))
              : _createCommentVNode("", true),
            _createVNode(FormTextarea, {
              modelValue: _unref(cart).form.Voicing_Script,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(cart).form.Voicing_Script) = $event)),
              "auto-grow": true,
              placeholder: _unref(setup).messagePlaceholderText
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("span", _hoisted_10, "Total word count: " + _toDisplayString(_unref(cart).scriptWordCount) + " words. 30 seconds max (app. 80 words): 80 words left", 1),
            _withDirectives(_createVNode(FormTextarea, {
              modelValue: _unref(cart).form.Notes_for_Producer,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(cart).form.Notes_for_Producer) = $event)),
              "auto-grow": true,
              placeholder: "Other Comments? Tell us Who is your Phone Provider and your Voicemail Pin Number."
            }, null, 8, ["modelValue"]), [
              [_vShow, _unref(setup).showProductionNotes]
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(CustomButton, {
                  color: "primary",
                  fill: "solid",
                  disabled: !_unref(cart).ready,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (next()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      size: "small",
                      icon: _unref(chevronForwardSharp)
                    }, null, 8, ["icon"]),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})